import { Component, Input, ViewChild, ElementRef } from '@angular/core';

/**
 * Generated class for the ShowVideoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'show-video',
  templateUrl: 'show-video.html',
})
export class ShowVideoComponent {

  @Input() src;
  @ViewChild('video') video: ElementRef;

  constructor() {
    console.log('Hello ShowVideoComponent Component');
  }

  playVideo() {
    this.video.nativeElement.play();
  }
}



// WEBPACK FOOTER //
// ./src/components/show-video/show-video.ts